import axios from '@/jslib/axios'

export const unassign = params => {
  return axios({
    method: 'get',
    url: '/admin/unassign',
    params
  })
}
